import React from "react";
import step1 from "./step1.svg";
import step2 from "./step2.svg";
import SciensHaloLogo from "./SciensHaloLogo.svg";

const IosInstallGuide = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-white overflow-y-auto">
      <div className="px-5 py-3 ">
        <img
          src={SciensHaloLogo}
          alt="SciensLogistics Halo Logo"
          className="h-14"
        />
      </div>
      <div className="max-w-md mx-auto px-4 py-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-xl font-bold text-center flex-grow">
            Steps to Install:
          </h1>
        </div>

        {/* Step 01 */}
        <div className="mb-6">
          <h2 className="font-semibold text-gray-800 mb-1">Step 01</h2>
          <p className="text-sm text-gray-600 mb-2">
            Tap the <strong>Share</strong> button in Safari.
          </p>
          <img
            src={step1}
            alt="Tap Share Button"
            className="w-full h-auto rounded-lg border shadow-sm"
          />
        </div>

        {/* Step 02 */}
        <div className="mb-6">
          <h2 className="font-semibold text-gray-800 mb-1">Step 02</h2>
          <p className="text-sm text-gray-600 mb-2">
            Scroll down and select <strong>"Add to Home Screen"</strong>.
          </p>
          <img
            src={step2}
            alt="Add to Home Screen"
            className="w-full h-auto rounded-lg border shadow-sm"
          />
        </div>

        {/* Step 03 */}
        <div className="mb-8">
          <h2 className="font-semibold text-gray-800 mb-1">Step 03</h2>
          <p className="text-sm text-gray-600">
            Open the Sciens Halo app from your home screen.
          </p>
        </div>

        {/* Home Button */}
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="bg-primary-500 hover:bg-blue-700 rounded-lg text-white px-5 py-2 mb-4 shadow-md text-sm"
          >
            Go to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default IosInstallGuide;
